import React from 'react';
import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
	SkeletonBox,
	SkeletonAvatar,
	SkeletonTitle,
	SkeletonDescription,
	SkeletonFooter
} from '../StyleComponents';

const NotificationItemSkeleton = () => {
	const skeletons = [...Array(3)].map((_, index) => {
		const key = `notifyItem-skeleton-${index}`;
		return (
			<SkeletonBox key={key} padding={3}>
				<Grid container spacing={2}>
					<Grid size={{ xs:12, nd:2 }}>
						<SkeletonAvatar>
							<Skeleton
								variant='circular'
								width='60px'
								height='60px'
							/>
						</SkeletonAvatar>
					</Grid>
					<Grid size={{ xs:12, md:10 }}>
						<SkeletonTitle>
							<Skeleton variant='text' width='50px' height='20px' />
							<Skeleton variant='text' width='50px' height='20px' />
						</SkeletonTitle>
						<SkeletonDescription>
							<Skeleton variant='text' width='80%' height='20px' />
							<Skeleton variant='text' width='50%' height='10px' />
						</SkeletonDescription>
						<SkeletonFooter>
							<Skeleton variant='text' width='70px' height='30px' />
						</SkeletonFooter>
					</Grid>
				</Grid>
			</SkeletonBox>
		);
	});

	return (
		<Box display='flex' flexDirection='column' padding={2}>
			{skeletons}
		</Box>
	);
};

export default NotificationItemSkeleton;
